import React from 'react'
import { createContext, useState } from "react";
import axios from 'axios'
import { config } from '../config';

const ContactusContext = createContext();

export default ContactusContext;

export const ContactusProvider = ((props) => {
    const[contact, setContact] = useState({
        date:"",
        name:"",
        companyname:"",
        email:"",
        subject:"",
        text:""
      })
    const [contacts, setContacts] = useState([]);
    const [status, setStatus] = useState('')
   

    //Add contact
    const addContact = (contact) => {
      
        //console.log("Contact:", contact)
        contact.date = new Date().toLocaleDateString()
        var id = 1;
        if (contacts.length > 0) {
            id = contacts[contacts.length - 1].id + 1;
            console.log("New id:", id)
        }

        const newContact = { id, ...contact }
        setContacts([...contacts, newContact])
    }


    //Delete contact
    const deleteContact = (id, e) => {
        setContacts(contacts.filter((contact) => contact.id !== id))
    }

    
    const sendEmail = async (inputs) => {
   
        //addContact(inputs)

   
    //send email
        try{
            await axios.post(config.url.API_URL + "/deda_ai_api/contactus/send", {inputs},{
                withCredentials:true
            })
        }
            catch (err)
        {
                console.log(err)
        }
        
    }
    

    const getData = async () => {

        var messages = "";
     
        let getchatsstatus = {
              chats: [],
              status: 0
        }
  
        const user = 'administrator'
          
     
      
          try{
              const res = await axios.post(config.url.API_URL + "/deda_ai_api/contactus/get", {user}) 
              if (res.data.length > 0) {
                  messages = JSON.parse(res.data[0].messages)
                  //console.log("GetChats:", messages)
                  setContacts(messages)
                
                    
              }
              else{
                  // Handle case when res.data is empty
                  console.log("No data in res.data")
              }
          } 
          catch(err)
          {
              console.log("Received error:", err)
              if (err.response && err.response.status !== 409)
              {
                  getchatsstatus.status = err.response.status
                  return getchatsstatus;
              }
          }
         
          let chatsstatus = {chats: messages, status: 200}
          return chatsstatus;
    }
  
    const saveData = async () => {
      console.log("Save Data")
      const messages= JSON.stringify(contacts)
      const user = 'administrator'
      console.log("Contactus:", contacts)
      console.log("Contactus - Messages:", messages)
      try{
        await axios.post(config.url.API_URL + "/deda_ai_api/contactus/save", {user, messages},{
          withCredentials:true
        })
      }
      catch (err)
      {
        console.log(err)
      }
    }

    return <ContactusContext.Provider value={{
        contact,
        setContact,
        status,
        setStatus,

        contacts,
        getData,
        saveData,
        addContact,
        deleteContact,
        sendEmail,
       
    }}>
        {props.children}
    </ContactusContext.Provider>
})